"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
exports.default = (react_1.default.createElement(react_1.default.Fragment, null,
    react_1.default.createElement("path", { d: "M57.4304 40.8366C63.8605 23.1639 49.5642 5.08216 32.2044 5.00033C17.0428 4.92887 4.86455 16.4625 5.00114 31.5098C5.13649 46.4209 14.8925 59 31.2152 59C47.5378 59 52.4841 50.6545 52.4841 50.6545", stroke: "#1F232B", strokeWidth: "2.5", strokeLinecap: "round" }),
    react_1.default.createElement("path", { d: "M21 31.9231L27.8847 38.1017C29.071 39.1663 30.8827 39.1173 32.0098 37.9902L45 25", stroke: "currentColor", strokeWidth: "2.5", strokeLinecap: "round" })));
